import React from 'react';
import { Box, Chip, Paper, useTheme } from '@mui/material';
import FaceIcon from '@mui/icons-material/Face';
import TagIcon from '@mui/icons-material/Tag';

export default function VideoKeyword({ caption, onTagClick, setOpenSearch, setChipTitle }) {
  const theme = useTheme();
  if (!caption) return null;

  // 提取博主名，并去掉开头的 #
  const bloggerMatch = caption.match(/原创：#(\S+)/);
  const blogger = bloggerMatch?.[1]?.replace(/^#/, '');

  // 提取关键词（正则匹配出的字符串可能带 #，这里统一去掉）
  const keywordMatches = caption.match(/#(\S+?)\s/g) || [];
  const keywords = keywordMatches
    .map(k => k.replace(/^#/, '').trim()) // 去掉 # 并去除空格
    .filter(k => k && k !== blogger);     // 去掉空字符串和博主名
    

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
        {blogger && (
          <Chip
            label={blogger} // 已经去掉 #
            icon={<FaceIcon />}
            size="small"
            onClick={() => onTagClick?.('blogger', blogger)}
            sx={{
              bgcolor: theme.palette.primary.main + '66',
              color: theme.palette.primary.contrastText,
              fontWeight: 500,
              borderRadius: 2,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '& .MuiChip-icon': { color: theme.palette.primary.contrastText },
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: theme.shadows[4],
                bgcolor: theme.palette.primary.main + '88',
              },
            }}
          />
        )}
        {keywords.map((kw, index) => (
          <Chip
            key={index}
            label={kw} // 已经去掉 #
            size="small"
            variant="outlined"
            onClick={() => {
              setChipTitle(kw);
              setOpenSearch(true);
            }}
            sx={{
              color: theme.palette.text.primary,
              borderColor: theme.palette.divider,
              bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
              borderRadius: 2,
              cursor: 'pointer',
              fontWeight: 400,
              transition: 'all 0.2s ease',
              '& .MuiChip-icon': { color: theme.palette.text.disabled },
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: theme.shadows[2],
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
              },
            }}
          />
        ))}
      </Box>
    </Paper>
  );
}
